<div class="container-fluid">
    <div class="card">
      <div class="card-header">
        <div class="d-flex justify-content-between">
          <h4 class="font-weight-bold text-dark py">STUDENT REQUEST COURSES</h4>
        </div>
      </div>
      <div class="p-3">
        <div class="table-responsive" *ngIf="customers.length > 0; else noDataTemplate">
          <table class="table table-bordered display" [dtOptions]="dtOptions" datatable width="100%" cellspacing="0">
            <thead>
              <tr>
                <th>Requested Course</th>
                <th>Name</th>
                <th>Number</th>
                <th>District</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let customer of customers">
                <td>{{ customer.requested_course }}</td>
                <td>{{ customer.name }}</td>
                <td>{{ customer.number }}</td>
                <td>{{ customer.district }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <ng-template #noDataTemplate>
          <div class="d-flex justify-content-center">
            <p>No data available.</p>
          </div>
        </ng-template>
      </div>
    </div>
  </div>